import { Report } from "./Report.js";
import { createReportEntry } from "./createReportEntry.js";
export function appendReport(error, entry) {
    // NOTE We put the most recent report entry at the end,
    // because the end is closer to user's terminal output.
    if (error instanceof Report) {
        error.entries.push(entry);
        return error;
    }
    return new Report([createReportEntry(error), entry]);
}
//# sourceMappingURL=appendReport.js.map